import React, { Component } from 'react';

export class SubsectionIFrame extends Component {
    render() {
        const minHeight = this.props.minHeight;

        const iframeStyle = {
            border: "0",
            width: "100%",
            height: "100%",
            display: "block"
        };

        if (minHeight) {
            iframeStyle.minHeight = minHeight;
        }

        const wrapperStyle =
            minHeight !== undefined && minHeight !== null ? { minHeight } : undefined;

        return (
            <div className="subsection" style={wrapperStyle}>
                <iframe
                    src={this.props.src}
                    title={this.props.title || "Subsection iframe"}
                    style={iframeStyle}
                    allow={this.props.allow}
                    allowFullScreen={this.props.allowFullScreen}
                    loading={this.props.loading || "lazy"}
                    referrerPolicy={this.props.referrerPolicy}
                />
            </div>
        );
    }
}
